import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ArrayResponse} from '../models/array-response';
import {Language} from '../models/language';
import {SendBackResult} from '../models/send-back-result';

import {AppSettingsService} from './app-settings.service';
import {BaseRestService} from './base-rest.service';
import {BlockUIService} from './block-ui.service';

@Injectable()
export class LanguagesService extends BaseRestService {
  constructor(http: HttpClient, appSettingsService: AppSettingsService, blockUIService: BlockUIService) { super(http, appSettingsService, blockUIService); }

  protected get className(): string { return 'LanguagesService'; }

  protected get isAnonymous(): boolean { return true; }

  getList(): Observable<SendBackResult<ArrayResponse<Language>>> { return this.get<ArrayResponse<Language>>(`/cultures/common`); }
}
